'use client';

import { useEffect, useState } from 'react';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { Button } from 'rizzui';

export function LandingBackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => setVisible(window.scrollY > 300);

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, { passive: true });

    return () => window.removeEventListener('scroll', updateVisibility);
  }, []);

  return (
    <div
      className={`back-to-top-wrapper ${visible ? 'back-to-top-btn-show' : ''}`}
    >
      <Button
        variant="text"
        type="button"
        className="back-to-top-btn"
        aria-label="Back to top"
        onClick={() => {
        // A native smooth scroll would be re-eased by the smoother on top of its own
        // animation, so hand the trip to the smoother whenever one is running.
        const smoother = ScrollSmoother.get();
        if (smoother) smoother.scrollTo(0, true);
        else window.scrollTo({ top: 0, behavior: 'smooth' });
      }}
      >
        <svg
          width="12"
          height="7"
          viewBox="0 0 12 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M11 6L6 1L1 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
    </div>
  );
}
